import React from 'react'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import projectPhoto from '../assets/images/projects.jpg';

import DescImage from '../components/DescImage';
import TitleBtn from '../components/TitleBtn';
import ScrollToTop from '../components/ScrollToTop';
import ProjectsCont from '../components/ProjectsCont';
import BackArrow from '../components/BackArrow';
import ScrollDown from '../components/ScrollDown';

import {FullWrap, DetailContainer, DetailDesc, LowerSec} from '../components/StyledComponents/StyledComp';
import DownBtn from '../components/DownBtn';

function ProjectDetail() {

        useEffect(() => {
        // Calculate 1/4 of the total viewport height
            const timer = setTimeout(() => {
            const scrollAmount = window.innerHeight / 3;
    
            // 2. Trigger the scroll
            window.scrollTo({
                top: scrollAmount,
                behavior: 'smooth' 
            });
            }, 1000);
            return () => clearTimeout(timer);
        }, []);

    const navigate = useNavigate();
    const goBack=()=>{
        navigate(-1);
    }

    return (
        <FullWrap>
            <DetailContainer>
                <BackArrow />
                <DetailDesc>
                    <p className="title-text">Projects</p>
                    <div className="redline1"></div>
                    <div className="redline2"></div>
                    <div className="role">
                        <p className='title-lead' >Code that left</p>
                        <p className='title-lead' >my laptop!</p>
                    </div>
                    <DownBtn/>
                </DetailDesc>
                <DescImage photoSource={projectPhoto} />
                <ScrollDown/>
            </DetailContainer>

            <LowerSec>
                <ProjectsCont/>
                <div className="scroll-to-top">
                    <ScrollToTop/>
                </div>
            </LowerSec>

        </FullWrap>
    )
}



export default ProjectDetail;